import { Component, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of as RxOf } from 'rxjs/observable/of';
import { defer as _defer, cloneDeep as _cloneDeep } from 'lodash';

import {
  AbstractBlModal,
  ModalReason,
  BlRadioGroupComponent
} from '@blcloud/bl-ng-ui-component';

import {
  ISalesSlipSearchScreenActionSetting,
  FirstViewTabDivArray,
  InitialSortOrderDivArray
} from './sales-slip-search-screen-action-setting-modal.define';

@Component({
  templateUrl: './sales-slip-search-screen-action-setting-modal.component.html',
  styleUrls: ['./sales-slip-search-screen-action-setting-modal.component.scss']
})
export class SalesSlipSearchScreenActionSettingModalComponent extends AbstractBlModal {

  /** 画面動作設定 */
  _screenActionSetting: ISalesSlipSearchScreenActionSetting;

  /** 初期表示タブ項目リスト */
  _firstViewTabItems = FirstViewTabDivArray.map(
    item => {
      return { code: item.value, name: item.text };
    }
  );

  /** 初期ソート順項目リスト */
  _initialSortOrderItems = InitialSortOrderDivArray.map(
    item => {
      return { code: item.value, name: item.text };
    }
  );

  /** 初期カーソル項目入力コンポーネント */
  @ViewChild('firstViewTab') private firstViewTab: BlRadioGroupComponent;

  constructor(
  ) {
    super();
  }

  /**
   * @override
   */
  getResults(): any {
    return this._screenActionSetting;
  }

  /**
   * @override
   */
  onShown() {
    this._screenActionSetting = _cloneDeep(this.data.screenActionSetting);

    // 初期フォーカス
    _defer(() => {
      if (this.firstViewTab) {
        this.firstViewTab.focus();
      }
    });
  }

  /**
   * @override
   */
  dismiss(reason: ModalReason) {
    if (reason === ModalReason.Done) {
      this.validate().subscribe(
        result => {
          if (result) {
            this.emitDismissEvent(reason);
          }
        }
      );
    } else {
      // 確定以外はそのまま通知
      this.emitDismissEvent(reason);
    }
  }

  // ================================================================
  // private

  /**
   * 入力検証します。
   * @returns 検証結果
   */
  private validate(): Observable<boolean> {
    return RxOf(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/sales-slip-search-screen-action-setting-modal/sales-slip-search-screen-action-setting-modal.component.ts